'use strict'

import AlertTemplate from './template/AlertTemplate.vue';

const AlertModule = {
  install(Vue) {
      var AlertConstructor = Vue.extend(AlertTemplate);
      var alertInstance = null;

      var setAlertInstance = function (message, isConfirm) {
        if (alertInstance) {
          alertInstance.isShowModal = true;
          alertInstance.isConfirm = isConfirm;
          alertInstance.message = message;
          return;
        }

        alertInstance = new AlertConstructor({
          el: document.createElement('div'),
          data() {
            return {
              message: message,
              isConfirm: isConfirm
            };
          }
        });
      }

      const Alert = {
        alert : async function (message) {
          return new Promise((resolve) => {
            setAlertInstance(message, false);
            alertInstance.isShowModal = true;
            alertInstance.callback = function() {
              resolve();
            };
            document.body.appendChild(alertInstance.$el);            
          })
        },
        confirm : async function (message) {
          return new Promise((resolve) => {
            setAlertInstance(message, true);
            alertInstance.isShowModal = true;
            alertInstance.callback = function(result) {
              if (result) {
                resolve(true);
              } else {
                resolve(false);
              }
            };
            document.body.appendChild(alertInstance.$el);            
          })
        },        
        close : function () {
          if (alertInstance) {
            alertInstance.isShowModal = false;
            return;
          }
        }
      }

      window.$Alert = Alert
      Vue.Alert = Alert
      Vue.prototype.$Alert = Alert      
  }
}

export default AlertModule


// WEBPACK FOOTER //
// ./src/modules/alert.js